import { mergeChartTheme } from '@/util/chartTheme';

// dipake komponen yang render <apexchart :options> langsung, biar ikut tema tanpa reload
export default {
  // halaman export nyediain ini biar grafik tetap terang di kertas
  inject: { mzForceLight: { default: false } },
  computed: {
    chartTheme() {
      return this.mzForceLight ? 'light' : this.$store.state.theme.resolved;
    },
    // computed, bukan method di template, biar apexchart gak redraw tiap render ulang
    themedChartOptions() {
      return mergeChartTheme(this.chartOptions, this.chartTheme);
    },
  },
};
